<template>
  <el-dialog
      title="相关推荐"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false">
      <el-form :model="form" ref="form" label-width="auto" class="demo-ruleForm">
          <el-row :gutter="20">
              <el-col :span="8">
                  <el-form-item label="工具名称">
                      <el-input v-model="form.name" size="small" placeholder="请输入工具名称" :disabled="true"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label="工具最新版本">
                      <el-input v-model="form.lastVersionName" size="small" placeholder="请输入工具最新版本" :disabled="true"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label="所属功能分类">
                      <el-input v-model="form.type" size="small" placeholder="请输入所属功能分类" :disabled="true"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-form-item label="简介">
              <el-input type="textarea" :rows="2" size="small" v-model="form.introduction" placeholder="请输入简介" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="推荐工具" style="margin-bottom:0;">
          </el-form-item>
          <el-form-item class="recommend">
            <div v-if="toolsList.length>0" class="recommend-list">
                <el-checkbox-group v-model="form.checkToolsList">
                    <dl v-for="item in toolsList" :key="item.sort">
                        <dd><el-checkbox disabled>{{ item.name }}</el-checkbox></dd>
                        <dt><el-checkbox :label="i.name"  v-for="i in item.list" :key="i.id"></el-checkbox></dt>
                    </dl>
                </el-checkbox-group>
            </div>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="medium" @click="save">保存</el-button>
          <el-button size="medium" @click="closeDialog">取 消</el-button>
      </span>
  </el-dialog>
</template>
<script>
import {toolsAPI} from 'liankong-ui-api'  
export default {
  props:{
      vkey: {
          type: String
      }
  },
  data() {
      return {
          dialogVisible: false,
          form: {
              name: '',
              type:'',
              lastVersionName: '',
              introduction: '',
              description: '',
              checkToolsList:[]
          },
          toolsList:[],
          findToolsList:[],
      };
  },
  methods: {
      show(row) {
          this.dialogVisible = true;
          this.form={
              name: '',
              lastVersionName: '',
              introduction: '',
              description: '',
              checkToolsList:[],
              type:''
          },
          // 获取详情
          this.$store.dispatch('manage/public', {
              query: row.id,
              requestInterfaceName: 'toolDetailInfo'
          }).then(res=>{
              if(res.code == 0) {
                  this.form.id = res.data.id
                  this.form.name = res.data.name
                  this.form.lastVersionName = res.data.lastVersionName
                  this.form.introduction = res.data.introduction
                  this.form.type = res.data.type
              }
          })
          toolsAPI.getToolExceptById(row.id).then(res=>{
            if(res.code==0){
                const toolsCombination = {}
                // 遍历数据清洗数据
                res.data.forEach(element => {
                    if(toolsCombination[element.categoryUse]){
                        toolsCombination[element.categoryUse]['list'].push({
                            name:element.name,
                            icon:element.icon,
                            introduction:element.introduction,
                            frontInfo:element.frontInfo,
                            id:element.id,
                            toolSeq:element.toolSeq,// 三级 排序
                            futureFlag:element.futureFlag
                        })
                        toolsCombination[element.categoryUse]['list'].sort((a,b)=>a.toolSeq-b.toolSeq)
                    } else {
                        toolsCombination[element.categoryUse] = {}
                        toolsCombination[element.categoryUse]['name'] = element.categoryUseName
                        toolsCombination[element.categoryUse]['sort'] = element.useSeq
                        toolsCombination[element.categoryUse]['list'] = []
                        toolsCombination[element.categoryUse]['list'].push({
                            name:element.name,
                            icon:element.icon,
                            introduction:element.introduction,
                            frontInfo:element.frontInfo,
                            id:element.id,
                            toolSeq:element.toolSeq,// 三级 排序
                            futureFlag:element.futureFlag
                        })
                        toolsCombination[element.categoryUse]['list'].sort((a,b)=>a.toolSeq-b.toolSeq)
                    }
                    
        
                })
                this.toolsList = Object.values(toolsCombination).sort((a,b)=>a.sort-b.sort)
                this.findToolsList = res.data
                // console.log(this.toolsList)
            } else {
                this.$message.error(res.message)
            }
          })
          toolsAPI.getRecommendToolById({
            recommendId:row.id,
            onlineFlag:true
          }).then(res=>{
            if(res.code==0){
                this.form.checkToolsList = res.data.map(item=>item.name)
            } else {
                this.$message.error(res.message)
            }
          })
        
      },
      // 保存
      save() {
        let toolsObject = {
            recommendId:this.form.id,
            list:[]
        }
        if(this.form.checkToolsList==0){
        } else {
            toolsObject.list = this.form.checkToolsList.map((item,index)=>{
            const current = this.findToolsList.find(i=>i.name==item)
            return {
                recommendId:this.form.id,
                toolId:current.id,
                sort:index+1
            }
            })
        }
        
        toolsAPI.addRecommendBatch(toolsObject).then(res=>{
            if(res.code==0){
                this.$message.success('保存成功');
                this.$parent.formInline.pageNum = 1;
            } else {
                this.$message.error(res.message);
            }
            this.closeDialog();
        })
      },
      closeDialog() {
          this.dialogVisible = false;
      }
  }
};
</script>
<style lang="less" scoped>
/deep/ .recommend {
    .el-form-item__content {
        margin-left: 40px !important;
    }
dl {
    dd {
        margin-inline-start: 0px !important;
        margin:10px 0 0 10px;
        .el-checkbox{
            cursor: auto;
            .el-checkbox__input {
                display: none;
            }
            .el-checkbox__label {
                color: #606266;
                cursor: auto;
                font-weight: 400;
                font-size: 15px;
            }
        }
    }
    dt {
        margin-left: 25px;
        .el-checkbox {
            width: 135px;
        }
    } 
 }
}

</style>